// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"23":"5d7c94fe","76":"1bf4987e","231":"d688e92b","530":"bbe6db4c","535":"85a978fe"}[chunkId] + ".chunk.js");